import produce, { Draft } from 'immer';
import { ISetProject } from '@src/actions/project';
import { ServerProjectInfo } from '@modules/auth/components/types/project';

import * as actionTypes from '../../constants/actionTypes';

export const initialState = Object.freeze({
  project: (undefined as unknown) as ServerProjectInfo,
});

export type ProjectState = typeof initialState;

const project = (state: ProjectState = initialState, action: ISetProject) => {
  return produce<ProjectState>(state, (draft: Draft<ProjectState>) => {
    switch (action.type) {
      case actionTypes.SET_PROJECT:
        draft.project = action.project;
        return;
      default:
        return;
    }
  });
};

export default project;
